import { apiRequest } from '@utils/apiRequest';

export const getCategoryPath = async (categoryPath, categoryId, isBackOrForward = false) => {
    if ((categoryPath?.length == 0 || isBackOrForward) && categoryId != null) {
        let tProdCat = null;
        let tCurFolderId = categoryId;
        let tPath = [];

        while (tCurFolderId != null) {
            tProdCat = await apiRequest(async (api, crmId) => {
                return api.getTaskCategory(crmId, tCurFolderId);
            });

            tPath = [{ id: tCurFolderId, name: tProdCat.data.data.name }, ...tPath];
            tCurFolderId = tProdCat.data.data.parent_task_category_id;
        }

        return tPath;
    }
};
